module.exports = __webpack_public_path__ + "static/media/guide_use_220719.464f05e3.svg";